import { URL_SEARCH_KEY } from "constants/urlQueryKeys";

export const getSearchQuery = (urlParams: URLSearchParams) => {
  return decodeURIComponent(urlParams.get(URL_SEARCH_KEY) || "");
};
